import soda_logo_4 from "../img/soda_logo_4.svg";
import soda_logo_3 from "../img/soda_logo_3.svg";
import soda_logo_2 from "../img/soda_logo_2.svg";
import soda_logo_1 from "../img/soda_logo_1.svg";
import React from "react";


export default function MainLogo() {
    return (
        <div className="logo_container relative w100">
            <img
                src={soda_logo_4}
                alt="SodaVPN"
                loading="lazy"
                className="soda-logo absolute h100 img4"
            />
            <img
                src={soda_logo_3}
                alt="SodaVPN"
                loading="lazy"
                className="soda-logo absolute h100 img3"
            />
            <img
                src={soda_logo_2}
                alt="SodaVPN"
                loading="lazy"
                className="soda-logo absolute h100 img2"
            />
            <img
                src={soda_logo_1}
                alt="SodaVPN"
                loading="lazy"
                className="soda-logo absolute h100 img1"
            />
        </div>
    );
}


